import SDiagonalArrow from "@public/image/icon/diagonal-arrow.svg";
import { useState } from "react";
import { FAQResponseType } from "@/types/post";
import { cn } from "@/utils/cn";

interface FAQProps {
  faq: FAQResponseType;
}

function FAQ({ faq: { title, content } }: FAQProps) {
  const [isOpen, setOpen] = useState<boolean>(false);
  const BG_COLOR_CN = isOpen ? "bg-primary/5" : "bg-white";
  const ARROW_ROTATE_CN = isOpen ? "rotate-90" : "";
  const DESCRIPTION_CN = isOpen ? "max-h-[300px] opacity-100 pt-4 mt-4" : "max-h-0  opacity-0";

  return (
    <li
      className={cn("rounded-xl border border-lightgray px-6 py-5 transition-colors duration-300", BG_COLOR_CN)}
      onClick={() => {
        setOpen((prev) => !prev);
      }}
    >
      <div className="flex items-center justify-between gap-3">
        <h3 className="break-all text-20 font-medium">{title}</h3>
        <SDiagonalArrow
          className={cn("size-6 flex-shrink-0 fill-gray/50 transition-transform", ARROW_ROTATE_CN)}
          aria-label="오른쪽 상단 화살표"
        />
      </div>
      <p className={cn("overflow-y-auto border-t border-gray text-18 transition-all duration-200", DESCRIPTION_CN)}>{content}</p>
    </li>
  );
}

export default FAQ;
